const TYPES = {
    SET: 'users.set',
    SET_CURRENT: 'users.setCurrent',
};

export default TYPES;
